import {colors} from "@c10h/colors";
import NextImage from "@components/NextImage";
import React, {PropsWithChildren} from "react";
import {testColors} from "src/constants/Reason/getCareDiscoveryColorScheme";

import styles from "../stylesheets/grid.module.scss";

const PageContainer: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className = "",
  ...props
}) => <div className={`df fdc aic  ${className}`} {...props} />;

// eslint-disable-next-line react/display-name
const InnerContainer = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({className = "", ...props}, ref) => (
    <div ref={ref} className={`ph8 ph4-sm maxw42 w100p ${className}`} {...props} />
  ),
);

const Faq: React.FC<PropsWithChildren<{backgroundColor: string; patternSrc: string}>> = ({
  backgroundColor,
  patternSrc,
  children,
}) => (
  <PageContainer className="pb20 pb0-sm" style={{gridArea: "faq1", backgroundColor}}>
    <div className="minh20 minh16-lg w100p dn-sm pos-r mt20">
      <NextImage layout="fill" src={`/patterns/${patternSrc}`} alt="" priority />
    </div>
    <InnerContainer className="mt16 mt20-sm">{children}</InnerContainer>
  </PageContainer>
);

const stickyStyles = {
  position: "sticky",
  top: "9rem",
};

const emptyStyles = {};

const Action: React.FC<
  PropsWithChildren<{
    isSticky: boolean;
    hideGutters?: boolean;
  }>
> = ({isSticky, children, hideGutters}) => (
  <PageContainer className="bg-gray50 pb1" style={{gridArea: "book"}}>
    <InnerContainer className={`h100p pv4 ${hideGutters ? "ph0-f" : ""}`}>
      <div style={isSticky ? stickyStyles : emptyStyles}>{children}</div>
    </InnerContainer>
  </PageContainer>
);

const Insurances: React.FC<PropsWithChildren> = ({children}) => (
  <PageContainer style={{gridArea: "ins", backgroundColor: testColors.darkBlue}}>
    <InnerContainer className="pt20 pb10 pt10-sm">{children}</InnerContainer>
  </PageContainer>
);

const GlobalFaq: React.FC<PropsWithChildren> = ({children}) => (
  <PageContainer style={{gridArea: "faq2"}}>
    <InnerContainer>{children}</InnerContainer>
  </PageContainer>
);

const Grid: React.FC<PropsWithChildren> = ({children}) => (
  <>
    <div
      className={`${styles.grid} dg jcc`}
      style={{
        borderBottom: `1px solid ${colors.gray100}`,
      }}
    >
      {children}
    </div>
  </>
);

export const Wrapper = {
  Faq,
  Action,
  Insurances,
  GlobalFaq,
  Grid,
};
